import { Link } from "react-router-dom";
import { Shield, ArrowRight, CheckCheck, FolderOpen, MessageSquare, Bell } from "lucide-react";

export const LandingNav = () => (
  <header className="fixed top-0 inset-x-0 z-40 border-b border-white/5 bg-[#0a0d14]/80 backdrop-blur-xl" data-testid="landing-nav">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
      <a href="#top" className="flex items-center gap-2.5" data-testid="landing-logo">
        <span className="h-9 w-9 rounded-lg bg-amber-500 flex items-center justify-center"><Shield className="h-5 w-5 text-[#0a0d14]" /></span>
        <span className="font-head text-lg font-bold text-white">Patro<span className="text-amber-500">Gest</span>Pro</span>
      </a>
      <nav className="hidden md:flex items-center gap-8 text-sm text-slate-400">
        <a href="#funzionalita" className="hover:text-white transition-colors" data-testid="landing-nav-funzionalita">Funzionalità</a>
        <a href="#portali" className="hover:text-white transition-colors" data-testid="landing-nav-portali">Aree riservate</a>
        <a href="#sicurezza" className="hover:text-white transition-colors" data-testid="landing-nav-sicurezza">Sicurezza</a>
      </nav>
      <Link to="/login" data-testid="landing-login-btn"
        className="inline-flex items-center gap-1.5 rounded-full bg-amber-500 hover:bg-amber-400 px-4 py-1.5 text-xs sm:text-sm font-semibold text-[#0a0d14] transition-colors">
        Accedi al Gestionale <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  </header>
);

const Mockup = () => (
  <div className="relative pgp-fade-up" style={{ animationDelay: "200ms" }} aria-hidden="true">
    <div className="absolute -inset-6 bg-amber-500/10 blur-3xl rounded-full" />
    <div className="relative rounded-2xl border border-white/10 bg-[#111722] p-4 shadow-2xl">
      <div className="flex gap-1.5 mb-4"><span className="h-2.5 w-2.5 rounded-full bg-red-400/70" /><span className="h-2.5 w-2.5 rounded-full bg-amber-400/70" /><span className="h-2.5 w-2.5 rounded-full bg-emerald-400/70" /></div>
      <div className="grid grid-cols-3 gap-3 mb-4">
        {[["Pratiche aperte", FolderOpen], ["Messaggi", MessageSquare], ["Scadenze", Bell]].map(([l, I]) => (
          <div key={l} className="rounded-xl bg-white/5 p-3"><I className="h-4 w-4 text-amber-400 mb-2" /><div className="h-2 w-16 rounded bg-white/20 mb-1.5" /><div className="text-[11px] text-slate-400">{l}</div></div>
        ))}
      </div>
      <div className="space-y-2">
        {[80, 65, 72, 55].map((w, i) => (
          <div key={i} className="flex items-center gap-3 rounded-lg bg-white/[0.03] px-3 py-2.5">
            <span className="h-7 w-7 rounded-md bg-amber-500/15" />
            <div className="flex-1"><div className="h-2 rounded bg-white/20" style={{ width: `${w}%` }} /><div className="h-2 mt-1.5 rounded bg-white/10 w-1/3" /></div>
            <CheckCheck className="h-4 w-4 text-sky-400" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const LandingHero = () => (
  <section id="top" className="relative overflow-hidden pt-32 pb-24 sm:pt-40 sm:pb-32" data-testid="landing-hero">
    <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)", backgroundSize: "48px 48px" }} />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-[1.1fr_1fr] gap-14 items-center">
      <div className="pgp-fade-up">
        <span className="inline-block rounded-full border border-amber-500/30 bg-amber-500/10 px-3 py-1 text-xs font-mono uppercase tracking-wider text-amber-400">Software gestionale per l'infortunistica stradale</span>
        <h1 className="mt-6 font-head text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] text-white">
          Ogni pratica di sinistro, <span className="text-amber-500">sotto controllo.</span>
        </h1>
        <p className="mt-6 max-w-xl text-base sm:text-lg text-slate-400 leading-relaxed">
          PatroGestPro è la piattaforma online pensata per gli studi di patrocinio e infortunistica stradale: pratiche, clienti, compagnie, lettere, allegati e comunicazioni in un unico gestionale, accessibile da qualsiasi dispositivo.
        </p>
        <div className="mt-9 flex flex-wrap gap-3">
          <a href="#funzionalita" data-testid="landing-cta-features" className="inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 px-6 py-3 text-sm font-semibold text-[#0a0d14] transition-colors">Scopri le funzionalità <ArrowRight className="h-4 w-4" /></a>
          <a href="#portali" data-testid="landing-cta-portali" className="inline-flex items-center rounded-full border border-white/15 hover:border-white/30 px-6 py-3 text-sm font-semibold text-white transition-colors">Aree riservate</a>
        </div>
      </div>
      <Mockup />
    </div>
  </section>
);
